module.exports = __webpack_public_path__ + "img/sl.984cb901.svg";